var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", {
      staticClass:
        "bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0",
      staticStyle: { height: "50px" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-col md:flex-row" }, [
      _c(
        "div",
        { staticClass: "main-content flex-1 bg-gray-100 mt-12 md:mt-2" },
        [
          _c(
            "div",
            { staticClass: "bg-blue-800 p-2 shadow text-xl text-white" },
            [
              _c(
                "div",
                { staticClass: "bg-grey-lighter min-h-screen flex flex-col" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white px-6 py-8 rounded shadow-md text-black w-full"
                        },
                        [
                          _c("img", {
                            staticClass: "m-auto mb-10",
                            staticStyle: { width: "150px" },
                            attrs: {
                              src: require("@/assets/musicverse-logo.png")
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "h1",
                            { staticClass: "mb-8 text-3xl text-center" },
                            [_vm._v("Set your new password")]
                          ),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              attrs: { autocomplete: "off" },
                              on: { submit: _vm.submitChangePassword }
                            },
                            [
                              !_vm.successResetPassword
                                ? _c("div", [
                                    _vm.$v.password.$dirty &&
                                    !_vm.$v.password.required
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-red-500 text-xs italic text-left"
                                          },
                                          [_vm._v("Please fill the password.")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "relative" }, [
                                      (_vm.showPassword
                                        ? "text"
                                        : "password") === "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.password,
                                                expression: "password"
                                              }
                                            ],
                                            staticClass:
                                              "block border border-grey-light w-full p-3 rounded mb-4",
                                            attrs: {
                                              name: "password",
                                              placeholder: "Password",
                                              autocomplete: "off",
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.password
                                              )
                                                ? _vm._i(_vm.password, null) >
                                                  -1
                                                : _vm.password
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = _vm.password,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.password = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.password = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.password = $$c
                                                }
                                              }
                                            }
                                          })
                                        : (_vm.showPassword
                                            ? "text"
                                            : "password") === "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.password,
                                                expression: "password"
                                              }
                                            ],
                                            staticClass:
                                              "block border border-grey-light w-full p-3 rounded mb-4",
                                            attrs: {
                                              name: "password",
                                              placeholder: "Password",
                                              autocomplete: "off",
                                              type: "radio"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.password,
                                                null
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.password = null
                                              }
                                            }
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.password,
                                                expression: "password"
                                              }
                                            ],
                                            staticClass:
                                              "block border border-grey-light w-full p-3 rounded mb-4",
                                            attrs: {
                                              name: "password",
                                              placeholder: "Password",
                                              autocomplete: "off",
                                              type: _vm.showPassword
                                                ? "text"
                                                : "password"
                                            },
                                            domProps: { value: _vm.password },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.password =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "absolute top-0 right-0 mr-2 mt-3 ",
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "text-blue-500",
                                            attrs: {
                                              icon: [
                                                "fa",
                                                _vm.showPassword
                                                  ? "eye-slash"
                                                  : "eye"
                                              ]
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.$v.repassword.$dirty &&
                                    !_vm.$v.repassword.required
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-red-500 text-xs italic text-left"
                                          },
                                          [
                                            _vm._v(
                                              "Please fill the confirm password."
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$v.repassword.$dirty &&
                                    !_vm.$v.repassword.sameAsPassword
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-red-500 text-xs italic text-left"
                                          },
                                          [
                                            _vm._v(
                                              "Please fill correct the confirm password."
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "relative" }, [
                                      (_vm.showConfirmPassword
                                        ? "text"
                                        : "password") === "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.repassword,
                                                expression: "repassword"
                                              }
                                            ],
                                            staticClass:
                                              "block border border-grey-light w-full p-3 rounded mb-4",
                                            attrs: {
                                              name: "confirm_password",
                                              placeholder: "Confirm Password",
                                              autocomplete: "off",
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.repassword
                                              )
                                                ? _vm._i(_vm.repassword, null) >
                                                  -1
                                                : _vm.repassword
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = _vm.repassword,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.repassword = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.repassword = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.repassword = $$c
                                                }
                                              }
                                            }
                                          })
                                        : (_vm.showConfirmPassword
                                            ? "text"
                                            : "password") === "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.repassword,
                                                expression: "repassword"
                                              }
                                            ],
                                            staticClass:
                                              "block border border-grey-light w-full p-3 rounded mb-4",
                                            attrs: {
                                              name: "confirm_password",
                                              placeholder: "Confirm Password",
                                              autocomplete: "off",
                                              type: "radio"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.repassword,
                                                null
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.repassword = null
                                              }
                                            }
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.repassword,
                                                expression: "repassword"
                                              }
                                            ],
                                            staticClass:
                                              "block border border-grey-light w-full p-3 rounded mb-4",
                                            attrs: {
                                              name: "confirm_password",
                                              placeholder: "Confirm Password",
                                              autocomplete: "off",
                                              type: _vm.showConfirmPassword
                                                ? "text"
                                                : "password"
                                            },
                                            domProps: { value: _vm.repassword },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.repassword =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "absolute top-0 right-0 mr-2 mt-3 ",
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              _vm.showConfirmPassword = !_vm.showConfirmPassword
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "text-blue-500",
                                            attrs: {
                                              icon: [
                                                "fa",
                                                _vm.showConfirmPassword
                                                  ? "eye-slash"
                                                  : "eye"
                                              ]
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w-full content-center py-3 rounded bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1",
                                        attrs: {
                                          type: "submit",
                                          disabled: _vm.isLoading
                                        },
                                        on: { click: _vm.submitChangePassword }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.labelForgotPassword)
                                        ),
                                        _vm.isLoading
                                          ? _c("img", {
                                              staticClass: "m-auto",
                                              attrs: {
                                                src: require("@/assets/bars.svg"),
                                                width: "30px"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.successResetPassword
                                ? _c("div", [
                                    _c(
                                      "h1",
                                      {
                                        staticClass: "mb-8 text-2xl text-center"
                                      },
                                      [_vm._v("Reset password success!")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-base" },
                                      [
                                        _vm._v("Click "),
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "text-blue-400 cursor-pointer",
                                            attrs: { to: { name: "Signin" } }
                                          },
                                          [_vm._v("here")]
                                        ),
                                        _vm._v(" to login with new password")
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1effb4b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1effb4b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChangePassword.vue
// module id = null
// module chunks = 